import React from 'react';
import PropTypes from 'prop-types';
import {
  WavesContainerStyled,
  FirstSceneLayerStyled,
  SecondSceneLayerStyled,
  ThridSceneLayerStyled,
} from './styles/ContentSceneStyled';

import { ReactComponent as MainWave } from '../../../../images/portalCautivo/wave1.svg';
import { ReactComponent as SecondWave } from '../../../../images/portalCautivo/wave2.svg';
import { ReactComponent as ThrirdWave } from '../../../../images/portalCautivo/wave3.svg';

const HeaderScene = ({ buying, carrierBillingPanel }) => {
  return (
    <WavesContainerStyled
      buying={buying}
      carrierBillingPanel={carrierBillingPanel}
    >
      <FirstSceneLayerStyled carrierBillingPanel={carrierBillingPanel}>
        <MainWave />
      </FirstSceneLayerStyled>
      <SecondSceneLayerStyled carrierBillingPanel={carrierBillingPanel}>
        <SecondWave />
      </SecondSceneLayerStyled>
      <ThridSceneLayerStyled carrierBillingPanel={carrierBillingPanel}>
        <ThrirdWave />
      </ThridSceneLayerStyled>
    </WavesContainerStyled>
  );
};

HeaderScene.defaultProps = {
  carrierBillingPanel: false,
};

HeaderScene.propTypes = {
  buying: PropTypes.bool.isRequired,
  carrierBillingPanel: PropTypes.bool,
};

export default HeaderScene;
